import React from "react";
import { useQuery } from "@apollo/client";
import client from "client";
import Catalog from "pages/SourcePage/Catalog";
import { QUERY_SOURCES } from "pages/SourcePage/SourcesQueries";
import Loader from "components/Loader/Loader";

const CatalogContainer = () => {
  const { loading, error, data } = useQuery(QUERY_SOURCES, {
    client,
    variables: {
      tenantID: parseInt(localStorage.defaultTenantID),
    },
  });

  if (loading)
    return <Loader minHeight={500} col={"col-1"} size="circle-scale--sm" />;
  if (error) return <div>{error.message}</div>;

  return (
    <div className="container-fluid">
      <main className="container-main">
        <div className="d-flex flex-row mb-2">
          <div className="pb-5 w-100 bg-light">
            <Catalog sources={data.connectors} />
          </div>
        </div>
      </main>
    </div>
  );
};
export default CatalogContainer;
